import classNames from 'classnames';
import { FunctionComponent, h } from 'preact';

type Props = h.JSX.HTMLAttributes<HTMLDivElement> & {
    className?: string;
};

export const ModalTitle: FunctionComponent<Props> = ({ className, ...rest }) => (
    <div {...rest} className={classNames('c-modal__title', className)} />
);
